class Slider {
  constructor(slider, options) {
    this.slider = slider;
    this.options = options;
    this.init();
  }

  init() {
    let defaults = {
      arrows: true,
      prevArrow: "",
      nextArrow: "",
      dots: false,
      speed: 400,
      infinite: false,
      slidesToShow: 1,
    };

    const options = Object.assign(defaults, this.options);
    this.slider.slick(options);
  }
}

var isDesktop = window.matchMedia("(width >= 1024px)").matches;

function slider() {
  if (!isDesktop) {
    return false;
  }

  const slider = $(".product-slider__slides");
  const sliderContainer = $(".product-slider");

  if (!slider.length) {
    return false;
  }

  const galleryLink = $(".product-gallery__link");
  const sliderOptions = {
    prevArrow: $(".product-slider__control--prev"),
    nextArrow: $(".product-slider__control--next"),
    variableWidth: true,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  function openSlider(slide = 1) {
    sliderContainer.addClass("is-open");
    slider.slick("slickGoTo", slide);
  }

  function closeSlider() {
    sliderContainer.removeClass("is-open");
  }

  // Listen for slider init
  slider.on("init", () => {
    galleryLink.on("click", function () {
      const thisSlide = $(this).data("position");
      openSlider(thisSlide);
    });

    $(".product-slider__slides, .product-slider__controls").on(
      "click",
      function (e) {
        e.stopPropagation();
      },
    );

    sliderContainer.on("click", closeSlider);
  });

  // Init Gallery Slider
  new Slider(slider, sliderOptions);
}

function mobileLayout() {
  if (!isDesktop) {
    const slider = $(".product-gallery .columns");
    const sliderOptions = {
      dots: true,
      infinite: true,
    };

    // Remove small gallery and desktop slider
    $(".product-gallery__small").remove();
    $(".product-gallery__slider").remove();

    // Init slider for Gallery
    new Slider(slider, sliderOptions);
  }
}

$(document).ready(function () {
  mobileLayout();
  slider();
})
